// <reference path="../node_modules/typescript/lib/lib.es6.d.ts" />
/// <reference path="common.d.ts" />
//import {disableDebugTools} from "@angular/platform-browser";
import {ModuleWithProviders, NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {AppComponent} from "./app.component";
import {
  AccordionModule, AutoCompleteModule, BreadcrumbModule, CalendarModule, CarouselModule, ChartModule, ButtonModule, CheckboxModule, CodeHighlighterModule, SharedModule, ContextMenuModule, DataGridModule, DataListModule, DataScrollerModule, DataTableModule, DialogModule,
  DragDropModule, DropdownModule, EditorModule, FieldsetModule, GalleriaModule, GMapModule, GrowlModule, InputMaskModule, InputSwitchModule, InputTextModule, InputTextareaModule, LightboxModule, ListboxModule, MegaMenuModule, MenubarModule, MenuModule, MessagesModule,
  MultiSelectModule, OrderListModule, OverlayPanelModule, PaginatorModule, TreeModule, TreeTableModule, TooltipModule, ToolbarModule, ToggleButtonModule, TieredMenuModule, TerminalModule, TabViewModule, TabMenuModule, SplitButtonModule, SpinnerModule, SliderModule, SlideMenuModule,
  SelectButtonModule, ScheduleModule, RatingModule, ProgressBarModule, RadioButtonModule, PasswordModule, PickListModule, PanelMenuModule, PanelModule
} from "primeng/primeng";
/* import {ConfirmDialogModule} from "primeng/components/confirmdialog/confirmdialog"; */
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ReactiveFormsModule} from "@angular/forms";
//import {InMemoryWebApiModule} from "angular-in-memory-web-api";
import {WFocusInputModule} from "./modules/components/w-focus-input";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {AppExceptionHandlerModule} from "./app-exception-handler.module";
import {LocationStrategy} from "@angular/common";
import {HashLocationStrategy} from "@angular/common";
import {AccountHandlingComponent} from "./common/account-handling.component";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {ModalModule} from "ngx-bootstrap";
import {RecaptchaModule} from "ng-recaptcha";
import {RouterModule} from "@angular/router";
import {CookieService} from "ngx-cookie-service";

//disableDebugTools();

@NgModule({
  imports: [
    //InMemoryWebApiModule,
    BrowserModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppExceptionHandlerModule,

    WFocusInputModule,
    //*** PrimeNG ***//
    //AccordionModule,
    //AutoCompleteModule,
    //BreadcrumbModule,
    ButtonModule,
    //CalendarModule,
    //CarouselModule,
    //ChartModule,
    CheckboxModule,
    //CodeHighlighterModule,
    SharedModule,
    //ContextMenuModule,
    //DataGridModule,
    //DataListModule,
    //DataScrollerModule,
    //DataTableModule,
    //DialogModule,
    /* ConfirmDialogModule, */
    //DragDropModule,
    DropdownModule,
    //EditorModule,
    //FieldsetModule,
    /* FileUploadModule, */
    //GalleriaModule,
    //GMapModule,
    GrowlModule,
    //InputMaskModule,
    //InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    //LightboxModule,
    //ListboxModule,
    //MegaMenuModule,
    //MenuModule,
    //MenubarModule,
    MessagesModule,
    //MultiSelectModule,
    //OrderListModule,
    //OverlayPanelModule,
    //PaginatorModule,
    PanelModule,
    //PanelMenuModule,
    PasswordModule,
    //PickListModule,
    //ProgressBarModule,
    //RadioButtonModule,
    //RatingModule,
    //ScheduleModule,
    //SelectButtonModule,
    //SlideMenuModule,
    //SliderModule,
    //SpinnerModule,
    //SplitButtonModule,
    //TabMenuModule,
    //TabViewModule,
    //TerminalModule,
    //TieredMenuModule,
    //ToggleButtonModule,
    //ToolbarModule,
    //TooltipModule,
    //TreeModule,
    //TreeTableModule,
    ModalModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      }
    }),
    RecaptchaModule
  ],
  declarations: [AppComponent, AccountHandlingComponent],
  bootstrap: [AppComponent],
  providers: [
    CookieService,
    {provide: LocationStrategy, useClass: HashLocationStrategy},
  ],
  exports: [RouterModule]
})
export class AppModule {
}

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, 'View/assets/js/i18n/', '.json');
}

/*
let mainRoutes: any = [];

export const routes: ModuleWithProviders = RouterModule.forRoot(mainRoutes, {
  useHash: true,
  //errorHandler: AppRouterErrorHandler
});
*/
